var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c("v-client-table", {
        attrs: {
          name: "pendingPayment",
          data: _vm.tableData,
          columns: _vm.tableColumns,
          options: _vm.tableOptions,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "resend",
              fn: function (props) {
                return [
                  props.row.resend
                    ? _c(
                        "button",
                        {
                          staticClass: "btn",
                          class: _vm.$style.link,
                          on: {
                            click: function ($event) {
                              return _vm.handleResendPaymentInfo(
                                props.row.resend
                              )
                            },
                          },
                        },
                        [_vm._v(" 代碼重新寄送 ")]
                      )
                    : _vm._e(),
                ]
              },
            },
          ],
          null,
          false,
          2036911104
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }